import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { FaTimes } from "react-icons/fa";
import { airlineImageFn, phoneCodeImageFn } from "../helper/commonFunction";
import { ChevronDownIcon, ChevronUpIcon, FlightIcon, FlightIconDropdown, FlightLatestIcon, LocationIcon, NewHotelIcon } from '../helper/HwIcon';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import AsyncSelect from "react-select/async";


const DropDownIndicator = (props) => {
    const { selectProps } = props;
    if (selectProps?.selectType === 'excursion') {
        return null;
    }
    const isMenuOpen = Boolean(selectProps?.isMenuOpen);
    const type = selectProps?.selectType || selectProps?.type;
    const value = selectProps?.value;
    const showIndicator = type === 'country' || !value;

    if (!showIndicator) {
        return null;
    }

    return (
        <components.DropdownIndicator {...props}>
            <div
                className={`hw-select--chevron ${isMenuOpen ? "is-open" : ""}`}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "transform 0.2s ease",
                    transform: isMenuOpen ? "rotate(180deg)" : "rotate(0deg)"
                }}
            >
                <ChevronDownIcon />
            </div>
        </components.DropdownIndicator>
    );
};

const HwSelect = ({
    placeholder, options, onChangeFn, value, menuChnageFn, onInputChangeFn, loading,
    inputValue, menuOpen, isMulti, type, isError = false, width, className, async = false, loadOptions, defaultOptions, animatedSuggestions = [], inlineMenu = false
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const isMenuOpen = menuOpen !== undefined ? menuOpen : isOpen;

    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        if (type === "excursion" && !inputValue && !value) {
            const interval = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % animatedSuggestions.length);
            }, 1200);
            return () => clearInterval(interval);
        } else {
            setCurrentIndex(0);
        }
    }, [inputValue, value, type]);

    const AnimatedPlaceholder = (props) => {
        const isEmpty = !inputValue && !value;
        if (type !== "excursion" || !isEmpty) {
            return <components.Placeholder {...props}>{placeholder}</components.Placeholder>;
        }
        return (
            <div className="hw-animated-placeholder">  Search for
                {animatedSuggestions.map((text, index) => (
                    <span
                        key={index}
                        className={`hw-placeholder-item ${index === currentIndex ? "active" : ""}`}
                    >
                        {text}
                    </span>
                ))}
            </div>
        );
    };

    const loadingIndicator = () => {
        return <div className="lds-ellipsis">
            <div />
            <div />
            <div />
            <div />
        </div>;
    }

    const loadingMessageIndicator = () => {
        return (
            <Skeleton height="5vh" count={5} />
        );
    }

    const clearIndiator = (props) => {
        return (
            <components.ClearIndicator {...props}>
                <FaTimes style={{ color: "#FF0000", cursor: "pointer" }} />
            </components.ClearIndicator>
        );
    }

    const OptionsData = ({ data }) => {

        if (type === 'airport') {
            return (
                <>
                    <div className="d-flex hw-gapy10 hw-flight--list">
                        <FlightIconDropdown />
                        <div className="d-flex d-flex-column s1 hw-gapx4">
                            <span className="hw-black900 hw-fontWeight--500 hw-line--height1">{`${data?.restData?.city}, ${data?.restData?.country} (${data?.restData?.code})`}</span>
                            <span className="hw-gray650 hw-text14 hw-fontNormal hw-text--hidden hw-line--height1">{data?.restData?.name}</span>
                        </div>
                    </div>
                </>
            )
        } else if (type === 'country' || type === 'ratings') {
            return (
                <>
                    <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                        <span className="hw-black hw-fontWeight--500">{data.label}</span>
                    </div>
                </>
            )
        } else if (type === 'phone-code') {
            return (
                <>
                    <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                        <img alt={data.label} src={phoneCodeImageFn(data.country_code)} width={20} height={20} />
                        <span className="hw-black hw-fontWeight--500">{data.label}</span>
                    </div>
                </>
            )
        } else if (type === 'hotels') {
            return (
                <>
                    <div className="d-flex hw-gapy10 hw-flight--list">
                        {/* <LocationIcon width={24} height={24} style={{ minWidth: 24, minHeight: 24 }} /> */}
                        {data?.isCity ? (
                            <LocationIcon width={24} height={24} style={{ minWidth: 24, minHeight: 24 }} />
                        ) : (
                            <NewHotelIcon width={24} height={24} style={{ minWidth: 24, minHeight: 24 }} />
                        )}

                        <div className="d-flex d-flex-column hw-gapx4">
                            <span className="hw-black hw-fontWeight--500">{data.label}</span>
                            <span className="hw-black800 hw-text14">{data?.details?.address || data?.fullRegionName}</span>
                        </div>
                    </div>
                </>
            )
        } else if (type === 'excursion') {
            return (
                <>
                    <div style={{ display: "flex", alignItems: "center", flexDirection: "row", gap: "10px" }}>
                        <img className="hw-br--5" alt={data.label} src={data?.img} width={60} height={60} />
                        <span className="hw-black hw-fontWeight--500 hw-text14">{data.label}</span>
                    </div>
                </>
            )
        } else if (type === 'excursion-dest') {
            return (
                <div className="hw-select--optionRow">
                    <span className="hw-black hw-fontWeight--500 hw-text14">{data.label}</span>
                </div>
            )
        } else {
            return (
                <>
                    <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                        <img alt={data.label} src={airlineImageFn(data.value)} width={20} height={20} style={{ objectFit: "contain", height: "auto", maxWidth: "100%" }} />
                        <span className="hw-black hw-fontWeight--500 hw-text14">{data.label}</span>
                    </div>
                </>
            )
        }
    }

    const customOptions = (props) => {
        const { data, innerRef, innerProps, isFocused, isSelected } = props;
        return (
            <div
                className={`${className ?? ""} hw-flight--lists hw-select--option${isFocused ? " is-focused" : ""}${isSelected ? " is-selected" : ""}`}
                ref={innerRef}
                {...innerProps}
            >
                <OptionsData data={data} />
            </div>
        );
    }

    const filterOption = (option) => {
        return option;
    };

    const RenderComponent = async ? AsyncSelect : Select
    return (
        <RenderComponent
            loadOptions={loadOptions}
            defaultOptions={defaultOptions}
            placeholder={type === "excursion" ? " " : placeholder}
            options={options}
            filterOption={type === 'airport' ? filterOption : undefined}
            onChange={selected => onChangeFn(selected)}
            value={value}
            isSearchable={true}
            isClearable={type !== 'phone-code'}
            cacheOptions={true}
            onMenuOpen={() => {
                setIsOpen(true);
                if (typeof menuChnageFn === "function") {
                    menuChnageFn(true);
                }
            }}
            onMenuClose={() => {
                setIsOpen(false);
                if (typeof menuChnageFn === "function") {
                    menuChnageFn(false);
                }
            }}
            isMenuOpen={isMenuOpen}
            selectType={type}
            type={type}
            components={{
                DropdownIndicator: type !== 'excursion' ? DropDownIndicator : null,
                LoadingIndicator: loadingIndicator,
                LoadingMessage: loadingMessageIndicator,
                ClearIndicator: clearIndiator,
                Option: customOptions,
                Placeholder: AnimatedPlaceholder
            }}
            onInputChange={(newInputValue) => {
                onInputChangeFn && onInputChangeFn(newInputValue);
                return newInputValue;
            }}
            isLoading={loading}
            inputValue={inputValue}
            menuPortalTarget={inlineMenu ? null : document.body}
            menuPosition={inlineMenu ? "absolute" : "fixed"}
            maxMenuHeight={300}
            isMulti={isMulti}
            styles={{
                control: (base) => ({
                    ...base,
                    border: isError ? "1px solid red" : base.border,
                    borderColor: isMenuOpen ? "#3264FF" : (isError ? "red" : base.borderColor),
                    boxShadow: "none",
                    padding: (type === 'excursion' || type === 'excursion-dest') ? "1.5rem" : "5px",
                    width: width ?? "250px",
                    ...(inlineMenu ? { border: "none", borderRadius: 0, backgroundColor: "#fff" } : {}),
                }),

                menu: (base) => ({
                    ...base,
                    borderRadius: "8px",
                    marginTop: "10px",
                    backgroundColor: "#fff",

                    width: type === "hotels" ? "550px" : base.width,
                    minWidth: type === "hotels" ? "550px" : undefined,
                    ...(inlineMenu ? { position: "relative", marginTop: 0, boxShadow: "none", borderRadius: 0, border: "none", width: "100%" } : {}),
                }),

                menuList: (base) => ({
                    ...base,
                    ...(inlineMenu ? { paddingTop: 0, paddingBottom: 0 } : {}),
                }),

                menuPortal: base => ({
                    ...base,
                    zIndex: 9999
                })
            }}
        />
    );
};

export default HwSelect;